import defaultState from './state';

const SET_DEVICE_NAME = (state, token) => {
  state.deviceName = token;
};

const SET_DEVICE_TOKEN = (state, token) => {
  state.deviceToken = token;
};

const SET_ADVERTISING_TOKEN = (state, token) => {
  state.advertisingToken = token;
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

export default {
  SET_DEVICE_NAME,
  SET_DEVICE_TOKEN,
  SET_ADVERTISING_TOKEN,
  DESTROY,
};
